module.exports = __webpack_public_path__ + "img/poster.92085cdf.png";